<template>
  <v-data-table
    :headers="repairItemDataTableHeaders"
    :items="repairItemsInResume"
    class="elevation-1 my-5 mx-5"
    :search="searchRepairItems"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
    :item-class="isOutOfWarrantyClass"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t(titleName) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchRepairItems"
          append-icon="mdi-magnify"
          :label="$t('quotation_item_new_install_search')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-dialog v-model="isShowEditRemoveRepairItemDialog" persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ repairItemDialogTitle }}</span>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <v-container>
                <ValidationObserver ref="repairItem">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Number"
                        :label="$t('quotation_item_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Name"
                        :label="$t('quotation_item_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Unit"
                        :label="$t('quotation_item_unit')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Quantity"
                        :label="$t('quotation_item_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.RealQuantity"
                        :label="$t('installation_acceptance_item_real_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.OriginalSerialNumber"
                        :label="$t('engineer_item_original_serial_numbers')"
                        disabled
                        v-if="editedRepairItem.RemoveItem.SerialNumber"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.SerialNumber.Number"
                        :label="$t('quotation_item_serialnumber')"
                        disabled
                        v-if="editedRepairItem.RemoveItem.SerialNumber"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <ValidationProvider
                        :name="$t('installation_notice_item_buy_or_rent')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          v-model="editedRepairItem.RemoveItem.BuyOrRentType"
                          :items="allBuyOrRentType"
                          item-text="Name"
                          item-value="Type"
                          required
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          :error-messages="errors[0]"
                          @change="setBuyOrRentType"
                          @keyup.enter="setRemoveBuyOrRentTypeAutocomplete"
                          ref="removeBuyOrRentTypeAutocomplete"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_notice_item_buy_or_rent') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-autocomplete
                        v-model="editedRepairItem.RemoveItem.InstallPosition"
                        :items="allInstallPositionType"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('quotation_item_install_position')"
                        small-chips
                        multiple
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        disabled
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-checkbox
                        v-model="editedRepairItem.RemoveItem.IsPersonalFactor"
                        label="人為"
                        disabled
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-checkbox
                        v-model="editedRepairItem.RemoveItem.IsCustomerDevice"
                        :label="$t('quotation_item_is_customer_device')"
                        disabled
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-autocomplete
                        v-model="editedRepairItem.RemoveItem.CustomerDeviceType"
                        :items="customerDeviceTypeList"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('engineer_item_customer_device_type')"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-if="editedRepairItem.RemoveItem.IsCustomerDevice"
                        disabled
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedRepairItem.RemoveItem.HasAuthorize">
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-autocomplete
                        :items="gmTypeList"
                        item-text="Name"
                        item-value="Type"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-model="editedRepairItem.RemoveItem.GmServerType"
                        label="GM"
                        :disabled="isAcceptance || editedRepairItem.IsDone"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.AuthorizeItemSerialNumber"
                        label="授權序號"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedRepairItem.Reason">
                    <v-col>
                      <ValidationProvider
                        :name="$t('installation_acceptance_item_reason')"
                        rules="required"
                        v-slot="{ errors }"
                        v-if="
                          editedRepairItem.RemoveItem.Quantity * 1 !==
                            editedRepairItem.RemoveItem.RealQuantity * 1
                        "
                      >
                        <v-textarea
                          outlined
                          v-model="editedRepairItem.Reason"
                          :error-messages="errors[0]"
                          :disabled="isAcceptance || editedRepairItem.IsDone"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_acceptance_item_reason') }}
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                      <ValidationProvider
                        name="換GM Server原因"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-textarea
                          outlined
                          v-model="editedRepairItem.Reason"
                          :error-messages="errors[0]"
                          disabled
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            換GM Server原因
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeEditRepairItem">
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn color="green darken-1" text @click="addRepairItem">
                {{ $t('common_confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="isShowEditReturnRepairItemDialog" persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ repairItemDialogTitle }}</span>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <v-container>
                <ValidationObserver ref="repairItem">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.ReturnItem.Number"
                        :label="$t('quotation_item_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.ReturnItem.Name"
                        :label="$t('quotation_item_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.ReturnItem.Unit"
                        :label="$t('quotation_item_unit')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.ReturnItem.Quantity"
                        :label="$t('quotation_item_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.ReturnItem.RealQuantity"
                        :label="$t('installation_acceptance_item_real_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-text-field
                        v-model="editedRepairItem.ReturnItem.SerialNumber.Number"
                        :label="$t('quotation_item_serialnumber')"
                        disabled
                        v-if="editedRepairItem.ReturnItem.SerialNumber"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <ValidationProvider
                        :name="$t('installation_notice_item_buy_or_rent')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          v-model="editedRepairItem.ReturnItem.BuyOrRentType"
                          :items="allBuyOrRentType"
                          item-text="Name"
                          item-value="Type"
                          required
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          :error-messages="errors[0]"
                          @change="setBuyOrRentType"
                          @keyup.enter="setRemoveBuyOrRentTypeAutocomplete"
                          ref="removeBuyOrRentTypeAutocomplete"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_notice_item_buy_or_rent') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-autocomplete
                        v-model="editedRepairItem.ReturnItem.InstallPosition"
                        :items="allInstallPositionType"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('quotation_item_install_position')"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        disabled
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-checkbox
                        v-model="editedRepairItem.ReturnItem.IsPersonalFactor"
                        label="人為"
                        disabled
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-checkbox
                        v-model="editedRepairItem.ReturnItem.IsCustomerDevice"
                        :label="$t('quotation_item_is_customer_device')"
                        disabled
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                      <v-autocomplete
                        v-model="editedRepairItem.ReturnItem.CustomerDeviceType"
                        :items="customerDeviceTypeList"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('engineer_item_customer_device_type')"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-if="editedRepairItem.ReturnItem.IsCustomerDevice"
                        disabled
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedRepairItem.ReturnItem.HasAuthorize">
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-autocomplete
                        :items="gmTypeList"
                        item-text="Name"
                        item-value="Type"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-model="editedRepairItem.ReturnItem.GmServerType"
                        label="GM"
                        :disabled="isAcceptance || editedRepairItem.IsDone"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.ReturnItem.AuthorizeItemSerialNumber"
                        label="授權序號"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedRepairItem.Reason">
                    <v-col>
                      <ValidationProvider
                        :name="$t('installation_acceptance_item_reason')"
                        rules="required"
                        v-slot="{ errors }"
                        v-if="
                          editedRepairItem.RemoveItem.Quantity * 1 !==
                            editedRepairItem.RemoveItem.RealQuantity * 1
                        "
                      >
                        <v-textarea
                          outlined
                          v-model="editedRepairItem.Reason"
                          :error-messages="errors[0]"
                          :disabled="isAcceptance || editedRepairItem.IsDone"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_acceptance_item_reason') }}
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                      <ValidationProvider
                        name="換GM Server原因"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-textarea
                          outlined
                          v-model="editedRepairItem.Reason"
                          :error-messages="errors[0]"
                          disabled
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            換GM Server原因
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeEditRepairItem">
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn color="green darken-1" text @click="addRepairItem">
                {{ $t('common_confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="false"
          :isLoadingSaveBtn="false"
          :isShowDeleteDialog="isShowDeleteRepairItemDialog"
          :deleteMessage="'installation_acceptance_item_delete_dialog_message'"
          @closeDelete="closeDeleteRepairItem"
          @confirmDelete="confirmDeleteRepairItem"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn
        icon
        small
        class="mr-2"
        @click="isShowEditRepairItemDialogBtn(item)"
        :disabled="isAllTextFieldDisable || isAcceptance"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        icon
        small
        @click="isShowDeleteRepairItemDialogBtn(item)"
        :disabled="isAllTextFieldDisable || isDone"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:[`item.BomName`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.BomName }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.BomName }}
      </span>
    </template>
    <template v-slot:[`item.Number`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.Number }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.Number }}
      </span>
    </template>
    <template v-slot:[`item.Name`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.Name }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.Name }}
      </span>
    </template>
    <template v-slot:[`item.Unit`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.Unit }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.Unit }}
      </span>
    </template>
    <template v-slot:[`item.Quantity`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.Quantity }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.Quantity }}
      </span>
    </template>
    <template v-slot:[`item.RealQuantity`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.RealQuantity }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.RealQuantity }}
      </span>
    </template>
    <template v-slot:[`item.BuyOrRentType`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ turnBuyOrRentType(item.RemoveItem.BuyOrRentType) }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ turnBuyOrRentType(item.ReturnItem.BuyOrRentType) }}
      </span>
    </template>
    <template v-slot:[`item.OriginalSerialNumber`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.OriginalSerialNumber }}
      </span>
    </template>
    <template v-slot:[`item.SerialNumber`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId && item.RemoveItem.HasSerialNumber">
        {{ item.RemoveItem.SerialNumber.Number }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId && item.ReturnItem.HasSerialNumber">
        {{ item.ReturnItem.SerialNumber.Number }}
      </span>
    </template>
    <template v-slot:[`item.IsCustomerDevice`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.IsCustomerDevice }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.IsCustomerDevice }}
      </span>
    </template>
    <template v-slot:[`item.InstallPosition`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ turnData(item.RemoveItem.InstallPosition) }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ turnData(item.ReturnItem.InstallPosition) }}
      </span>
    </template>
    <template v-slot:[`item.WorkType`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ turnWorkTypeName(item.RemoveItem.WorkType) }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ turnWorkTypeName(item.ReturnItem.WorkType) }}
      </span>
    </template>
    <template v-slot:[`item.RelativeNumber`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        {{ item.RemoveItem.RelativeNumber }}
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        {{ item.ReturnItem.RelativeNumber }}
      </span>
    </template>
    <template v-slot:[`item.IsInQuotation`]="{ item }">
      <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
        <p v-if="!item.RemoveItem.IsInQuotation" style="color: darkred;">*</p>
      </span>
      <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
        <p v-if="!item.ReturnItem.IsInQuotation" style="color: darkred;">*</p>
      </span>
    </template>
    <template v-slot:[`header.IsInQuotation`]="{}">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="error" dark v-bind="attrs" v-on="on">
            mdi-information
          </v-icon>
        </template>
        <span>* 不在報價單</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import {
  HttpInstallPosition,
  HttpSerialNumber,
  HttpInstallationAcceptance,
  HttpQuotation,
  HttpAuthorizeMapping
} from '@/js/http-Manager'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { WorkType } from '@/js/WorkType'
import DeleteDialog from '@/components/DeleteDialog.vue'
export default {
  components: { DeleteDialog },
  name: 'RepairItemInResume',
  props: {
    repairItemsInResume: {
      type: Array,
      default () {
        return []
      }
    },
    isDone: {
      type: Boolean,
      default: false
    },
    isAcceptance: {
      type: Boolean,
      default: false
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    titleName: {
      type: String
    }
  },
  data: () => ({
    gmTypeList: [],
    searchRepairItems: '',
    isShowEditRemoveRepairItemDialog: false,
    isShowEditReturnRepairItemDialog: false,
    isShowDeleteRepairItemDialog: false,
    editedRepairItemIndex: -1,
    editedRepairItem: {
      RemoveItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false
      },
      ReturnItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2
      },
      Reason: ''
    },
    defaultRepairItem: {
      RemoveItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false
      },
      ReturnItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2
      },
      Reason: ''
    },
    allBuyOrRentType: [],
    allInstallPositionType: [],
    itemSerialNumberList: [],
    customerDeviceTypeList: []
  }),
  async mounted () {
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getCustomerDeviceType()
    await this.getGmTypeList()
  },
  computed: {
    repairItemDataTableHeaders () {
      return [
        { text: '', align: 'start', value: 'IsInQuotation', width: '5', sortable: false },
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'BomName'
        },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('installation_acceptance_item_real_quantity'),
          align: 'end',
          value: 'RealQuantity'
        },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('engineer_item_original_serial_numbers'),
          align: 'start',
          value: 'OriginalSerialNumber'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('engineer_item_work_type'),
          align: 'start',
          value: 'WorkType'
        },
        {
          text: '相對品號',
          align: 'start',
          value: 'RelativeNumber'
        },
        // {
        //   text: '相對品名',
        //   align: 'start',
        //   value: 'RelativeName'
        // },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    repairItemDialogTitle () {
      return this.editedRepairItemIndex === -1
        ? this.$t('installation_acceptance_item_add')
        : this.$t('installation_acceptance_item_edit')
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    isOutOfWarrantyClass (item) {
      if (item.RemoveItem.IsOutOfWarranty && item.RemoveItem.BuyOrRentType === 1) {
        return 'red'
      }
      if (item.RemoveItem.IsPersonalFactor) {
        return 'yellow'
      }
    },
    setRemoveBuyOrRentTypeAutocomplete (event) {
      this.$refs.removeBuyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.removeBuyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setReturnItemBuyOrRentTypeAutocomplete (event) {
      this.$refs.returnItemBuyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.returnItemBuyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setRemoveItemBuyOrRentTypeAutocomplete (event) {
      this.$refs.removeItemBuyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.removeItemBuyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    turnWorkTypeName (val) {
      return WorkType.getFormWorkTypeName(val)
    },
    async setEditedRemoveItem (val) {
      this.editedRepairItem.RemoveItem.ItemId = val.Id
      this.editedRepairItem.RemoveItem.Number = val.Number
      this.editedRepairItem.RemoveItem.Name = val.Name
      this.editedRepairItem.RemoveItem.Unit = val.Unit
      this.editedRepairItem.RemoveItem.Price = val.Price
      this.editedRepairItem.RemoveItem.IsMonthItem = val.IsMonthItem
      this.editedRepairItem.RemoveItem.IsDelete = val.IsDelete
      this.editedRepairItem.RemoveItem.StoreNo = val.StoreNo
      this.editedRepairItem.RemoveItem.RepairPrice = val.RepairPrice
      this.editedRepairItem.RemoveItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedRepairItem.RemoveItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedRepairItem.RemoveItem.IsCustomerDevice = val.IsCustomerDevice
      this.editedRepairItem.RemoveItem.HasSerialNumber = val.HasSerialNumber
      this.editedRepairItem.RemoveItem = JSON.parse(
        JSON.stringify(this.editedRepairItem.RemoveItem)
      )
      await this.getItemSerialNumber()
      this.setEditedReturnItem(val)
    },
    async setEditedReturnItem (val) {
      this.editedRepairItem.ReturnItem.ItemId = val.Id
      this.editedRepairItem.ReturnItem.Number = val.Number
      this.editedRepairItem.ReturnItem.Name = val.Name
      this.editedRepairItem.ReturnItem.Unit = val.Unit
      this.editedRepairItem.ReturnItem.Price = val.Price
      this.editedRepairItem.ReturnItem.IsMonthItem = val.IsMonthItem
      this.editedRepairItem.ReturnItem.IsDelete = val.IsDelete
      this.editedRepairItem.ReturnItem.StoreNo = val.StoreNo
      this.editedRepairItem.ReturnItem.RepairPrice = val.RepairPrice
      this.editedRepairItem.ReturnItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedRepairItem.ReturnItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedRepairItem.ReturnItem.IsCustomerDevice = val.IsCustomerDevice
      this.editedRepairItem.ReturnItem.HasSerialNumber = val.HasSerialNumber
      this.editedRepairItem.ReturnItem = JSON.parse(
        JSON.stringify(this.editedRepairItem.ReturnItem)
      )
      await this.getItemSerialNumber()
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    setBuyOrRentType () {
      let tempEdited = JSON.parse(JSON.stringify(this.editedRepairItem))
      this.editedRepairItem.BuyOrRentType = tempEdited.BuyOrRentType
    },
    async getItemSerialNumber () {
      let param = {
        itemId: this.editedRepairItem.ItemId
      }
      let response = await HttpSerialNumber.GetSerialNumberFromItemId(param)
      this.itemSerialNumberList = response.status === 200 ? response.data.Data : []
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async isShowEditRepairItemDialogBtn (item) {
      this.editedRepairItemIndex = this.repairItemsInResume.indexOf(item)
      this.editedRepairItem = JSON.parse(JSON.stringify(item))
      await this.getItemSerialNumber()
      if (
        this.editedRepairItem.RemoveItem &&
        typeof this.editedRepairItem.RemoveItem.ItemId !== 'undefined' &&
        this.editedRepairItem.RemoveItem.ItemId !== ''
      ) {
        this.isShowEditRemoveRepairItemDialog = true
      } else {
        this.isShowEditReturnRepairItemDialog = true
      }
    },

    isShowDeleteRepairItemDialogBtn (item) {
      this.editedRepairItemIndex = this.repairItemsInResume.indexOf(item)
      let str = JSON.stringify(item)
      this.editedRepairItem = JSON.parse(str)
      this.isShowDeleteRepairItemDialog = true
    },

    confirmDeleteRepairItem () {
      this.$emit('setDeleteItem', this.editedRepairItemIndex)
      this.closeDeleteRepairItem()
    },

    closeEditRepairItem () {
      this.isShowEditRemoveRepairItemDialog = false
      this.isShowEditReturnRepairItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultRepairItem)
        this.editedRepairItem = JSON.parse(str)
        this.editedRepairItemIndex = -1
      })
    },

    closeDeleteRepairItem () {
      this.isShowDeleteRepairItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultRepairItem)
        this.editedRepairItem = JSON.parse(str)
        this.editedRepairItemIndex = -1
      })
    },
    async addRepairItem () {
      const isValid = await this.$refs.repairItem.validate()
      if (isValid) {
        this.$emit('setEditedRepairItemIndex', this.editedRepairItemIndex)
        this.$emit('setEditedRemoveRepairItemInResume', this.editedRepairItem)
        this.closeEditRepairItem()
      }
    }
  }
}
</script>
